export default {

  password: {
    label: 'Current password',
    infoText: 'As a security measure, please confirm your current password before saving the changes.',
  },

};
